<div class="flex flex-wrap mt-4">
  <div class="w-full mb-12 px-4">
    <app-card-table></app-card-table>
  </div>
  <div class="w-full mb-12 px-4">
    <app-card-table color="dark"></app-card-table>
  </div>
</div>
